module.exports = __webpack_public_path__ + "img/step2.0b28b318.png";